import React from "react";
import { Card } from "..";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { ReactComponent as ExpiryDateCalendar } from "assets/icons/Clients_Flow_Icons/Red_Calendar.svg";
import { ReactComponent as RingIcon } from "assets/icons/CatalogueCard/ring.svg";
import { ReactComponent as ActiveLogIcon } from "assets/icons/CatalogueCard/active_log.svg";
import { ReactComponent as SessionIcon } from "assets/icons/Clients_Flow_Icons/SessionIcon.svg";

import profileImage from "../../../assets/img/profile.png";

import "./clientActiveExpiry.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useClientContext } from "context/ClientContext";
import { capitalEachLetter } from "utils/capitalEachLetter";

export const formatDateAndTime = (isoDate) => {
  if (!isoDate) return "-";

  const date = new Date(isoDate);

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const getDaySuffix = (day) => {
  if (day >= 11 && day <= 13) return "th";

  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatDateTimeWithSuffix = (isoDate) => {
  if (!isoDate) return "-";

  const date = new Date(isoDate);

  const day = date.getDate();
  const dayWithSuffix = `${String(day).padStart(2, "0")}${getDaySuffix(day)}`;

  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${dayWithSuffix} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
};

const ClientActiveExpiryCard = ({ data, isActiveCat = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setTimeSpentBtn, setRenewBtn, setShowExpiryTimer } = useClientContext();

  const handleNavigate = (catalogName, id, expiryDate) => {
    let expiryDateFormated = formatDateTimeWithSuffix(expiryDate);

    navigate(`${catalogName}`, { state: { ...location?.state, isSession: false, catalogId: id, expiryDate: expiryDateFormated } });
    setRenewBtn(false);
  };

  const hanldeSessionNavigate = (e, catalogName, catalogNumber, id) => {
    e.stopPropagation();
    let catalogDesignPath = encodeURIComponent(`#${catalogNumber}(${catalogName})Sessions`);
    navigate(catalogDesignPath, { state: { ...location?.state, isSession: true, catalogId: id } });
    setTimeSpentBtn(false);
    setShowExpiryTimer(false);
  };
  return (
    <Grid
      item
      className="active-expiry-container"
      onClick={() => {
        handleNavigate(data?.catalogName, data?._id, data?.expiryDateAndTime);
      }}
    >
      <Box className="top-container">
        <Typography className="catname">
        {data?.catalogName?.length > 20
        ? `${data.catalogName.slice(0, 20)}...`
        : data?.catalogName}
          <span> (#{data?.catalogNumber})</span>
        </Typography>
        <div className="active-session-iconsdiv">
          <IconButton disableFocusRipple disableRipple sx={{ padding: "0px !important" }}>
            <ActiveLogIcon />
          </IconButton>
          {!isActiveCat && (
            <IconButton disableFocusRipple disableRipple sx={{ padding: "0px !important" }} onClick={(e) => hanldeSessionNavigate(e, data?.catalogName, data?.catalogNumber, data?._id)}>
              <SessionIcon />
            </IconButton>
          )}
        </div>
      </Box>
      <Box className="bottom-container" sx={{ flexDirection: isActiveCat ? "column" : "row" }}>
        <div className="expiry-date-container">
          <div className="expiry-designs">
            <IconButton disableFocusRipple disableRipple>
              <RingIcon height={"20px"} width={"20px"} />
            </IconButton>
            <Typography className="design-count">{data?.designCount}</Typography>
          </div>
          {isActiveCat && (
            <div className="expiry-designs">
              <IconButton disableFocusRipple disableRipple>
                <ExpiryDateCalendar />
              </IconButton>
              <Typography className="design-count">{formatDateTimeWithSuffix(data?.expiryDateAndTime)}</Typography>
            </div>
          )}
        </div>

        <div className="createdby-container">
          <Typography className="createdby">
            {formatDateAndTime(data?.createdAt)} , {capitalEachLetter(`${data?.createdBy?.firstName} ${data?.createdBy?.lastName}`)}
            <img src={profileImage} alt={profileImage} style={{ width: "32px", height: "32px", borderRadius: "5vw", marginLeft: "0.8vw" }} />
          </Typography>
        </div>
      </Box>
    </Grid>
  );
};

export default ClientActiveExpiryCard;
